import { reactive } from 'vue'
import { api } from './api'
export const store = reactive({
  site: {}, plans: [], projects: [], profile: null, membership: null, ready: false,
  async load() { const data = await api.bootstrap(); Object.assign(this, data, { ready: true }); if (data.site.seoTitle) document.title = data.site.seoTitle },
  async loadProfile() { const data = await api.profile(); this.profile = data.user; this.membership = data.membership; return data.user },
  setProfile(profile) { this.profile = profile },
  logout() { localStorage.removeItem('token'); this.profile = null; this.membership = null }
})
